<template>
  <div class="progress-bar--multi-step">
      <span
        v-for="i in steps"
        :key="i"
        :class="{active: (i - 1) === value, clickable}"
        @click="clickable && i <= value && $emit('click', i - 1)"
        class="progress-bar__step">
      </span>
  </div>
</template>

<script>
  export default {
    name: 'WStepProgressBar',
    props: {
      steps: {
        type: Number,
        required: true,
      },
      value: {
        type: Number,
        required: true,
      },
      clickable: Boolean,
    },
  };
</script>

<style scoped lang="scss">
  @import "../../assets/styles/variables";

  .progress-bar--multi-step {
    width: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 4px 0;

    .progress-bar__step {
      display: block;
      width: 8px;
      height: 8px;
      background-color: $primary-light;
      margin: 0 3px;
      border-radius: 100%;
      box-sizing: border-box;
      transition: all 0.5s;

      &.active {
        width: 12px;
        height: 12px;
        background-color: $primary-main;
      }

      &.clickable {
        cursor: pointer;
      }
    }
  }
</style>
